<template>
  <div class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
    <div class="flex justify-between items-center mb-6">
      <h3 class="font-bold text-gray-800 text-lg">CBT / Assessments</h3>
      <span v-if="activeTests.length > 0" class="text-xs bg-primary/10 text-primary px-2 py-1 rounded-full font-medium">Active Now</span>
    </div>

    <div class="space-y-4">
      <!-- Active Tests -->
      <div v-for="test in activeTests" :key="test.id" class="p-4 border border-primary/20 bg-primary/10 rounded-xl flex items-center justify-between">
        <div class="flex items-center gap-4">
          <div class="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
             <i class="pi pi-desktop text-xl"></i>
          </div>
          <div>
            <h4 class="text-sm font-bold text-gray-800">{{ test.title }}</h4>
             <!-- Hardcoded class for now as it's not in the simplified API response, or we map it if available -->
            <p class="text-xs text-gray-500 mt-0.5">Ends at {{ formatTime(test.end_time) }}</p>
          </div>
        </div>
        <router-link :to="{ name: 'cbt-test-results', params: { testId: test.id } }" class="bg-primary text-white text-xs px-4 py-2 rounded-md hover:bg-primary/90 transition">
          Monitor
        </router-link>
      </div>

       <!-- Upcoming Tests -->
      <div v-for="test in upcomingTests" :key="test.id" class="p-4 border border-gray-100 rounded-xl flex items-center justify-between">
        <div class="flex items-center gap-4">
          <div class="w-10 h-10 rounded-lg bg-gray-50 flex items-center justify-center text-gray-500">
             <i class="pi pi-clock text-xl"></i>
          </div>
          <div>
            <h4 class="text-sm font-bold text-gray-800">{{ test.title }}</h4>
            <p class="text-xs text-gray-500 mt-0.5">Starts in {{ formatTime(test.start_time) }}</p>
          </div>
        </div>
      </div>

       <div v-if="activeTests.length === 0 && upcomingTests.length === 0" class="text-center text-gray-400 text-sm py-4">
        No active or upcoming assessments
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { format } from 'date-fns';
import type { DashboardStats } from '@/types/composition-functions';

// Extract types
type CbtTest = DashboardStats['activeCbtTests'][number];

defineProps<{
  activeTests: CbtTest[]
  upcomingTests: CbtTest[]
}>();

const formatTime = (dateStr: string) => {
  try {
    return format(new Date(dateStr), 'h:mm a');
  } catch (e) {
    return dateStr;
  }
};
</script>
